import { REQUEST_POINTS_TYPE, REQUEST_SUCCESS_POINTS_MAPPER } from "../constants/portfolio";
import { formatRequestSuccessPoints } from "../utils/portfolio/functions";

export const PORTFOLIO_LANDING = {
  screenDataAid: "portfolioLanding",
  headerRightIconDataAid: "right",
  errorText: "Currently, we’re having an issue loading your portfolio details",
  headerTitle: {
    text: "Portfolio",
    dataAid: "portfolioLanding",
  },
  investmentSummary: {
    keyTotalCurrent: {
      text: "Total current value",
      dataAid: "keyTotalCurrent",
    },
    valueTotalCurrent: {
      dataAid: "valueTotalCurrent",
    },
    currentValueIcon: {
      dataAid: "currentValue",
      iconDataAid: "right",
    },
    keyOneDayChange: {
      text: "1 day change:",
      dataAid: "keyOneDayChange",
    },
    valueOneDayChange: {
      dataAid: "valueOneDayChange",
    },
    investedKey: {
      text: "Invested amount",
      dataAid: "investedKey",
    },
    valueInvestedAmount: {
      dataAid: "valueInvestedAmount",
    },
    keyPl: {
      text: "P&L",
      dataAid: "keyP&L",
    },
    valuePl: {
      dataAid: "valueP&L",
    },
    realisedGain: {
      ctaTitle: "View realised gain",
      ctaDataAid: "realisedGain",
      iconDataAid: "right",
    },
    plIcon: {
      positiveDataAid: "positive",
      negativeDataAid: "negative",
    },
  },
  investmentSection: {
    title: {
      text: "Investments",
      dataAid: "investments",
    },
    viewAll: {
      ctaTitle: "View all",
      ctaDataAid: "viewAll",
      iconDataAid: "right",
    },
  },
  allocationSection: {
    title: {
      text: "Product allocation",
      dataAid: "investmentAllocation",
    },
    pillAssetWise: {
      text: "Asset-wise",
      dataAid: "assetWise",
      value: "asset_allocation",
    },
    pillProductWise: {
      text: "Product-wise",
      dataAid: "productWise",
      value: "product_allocation",
    },
  },
  bannerSection: {
    first: {
      iconDataAid: "banner",
    },
  },
  insurance: {
    dataAid: "insurance",
    title: "Insurance",
    subtitle: "Build a safety net for your future",
  },
  realisedGainSheet: {
    bottomsheetDataAid: "realisedGain",
    keyRealisedGain: {
      text: "Realised gain/loss",
      dataAid: "keyRealisedGain",
    },
    valueRealisedGain: {
      dataAid: "valueRealisedGain",
    },
    subtitle: {
      text: "Refers to the profit/loss you’ve made by selling funds at a price higher/lower than the original purchase price",
      dataAid: "subtitle",
    },
  },
  stocksFailed: {
    titleDataAid: "infoText",
    refreshBtnDataAid: "button_secondary",
  }
};

export const ALL_INVESTMENTS_LANDING = {
  screenDataAid: "allInvestments",
  topInvestmentSection: {
    screenTitle: {
      text: "Investments",
      dataAid: "allInvestments",
    },
    keyCurrent: {
      text: "Current value",
      dataAid: "keyCurrent",
    },
    valueCurrent: {
      dataAid: "valueCurrent",
    },
    keyPl: {
      text: "P&L",
      dataAid: "keyP&L",
    },
    valuePl: {
      dataAid: "valueP&L",
    },
  },
};

export const RETURN_CALCULATOR = {
  sheetId: 'returnCalculator',
  sheetTitle: {
    text: "Return calculator",
    dataAid: "returnCalculator",
  },
  pillMutualFund: {
    text: "Mutual Funds",
    dataAid: "mutualFunds",
    value: "mutual_funds",
  },
  pillStocks: {
    text: "Stocks",
    dataAid: "stocks",
    value: "stocks",
  },
  amount: {
    dataAid: "amount",
  },
  slider: {
    dataAid: "returnCalculator",
  },
  investmentPeriod: {
    text: "Investment period",
    dataAid: "investmentPeriod",
  },
  valueInvested: {
    dataAid: "valueInvested",
  },
  keyInvested: {
    text: "Invested",
    dataAid: "keyInvested",
  },
  valueEstimatedReturn: {
    dataAid: "valueEstimatedReturn",
    infoIconDataAid: "info",
  },
  keyEstimatedReturn: {
    text: "Estimated return",
    dataAid: "keyEstimatedReturn",
  },
  valueEstimatedReturnPer: {
    dataAid: 'valueEstimatedReturnPer',
  },
  cta: {
    dataAid: "primary",
    title: "Start investing",
  },
};

export const MF_LANDING = {
  screenDataAid: "mutualFundPortfolio",
  navigationHeader: {
    title: "Mutual funds",
    dataAid: "mutualFundPortfolio",
  },
  investmentSummary: {
    keyTotalCurrent: {
      text: "Total current value",
      dataAid: "keyTotalCurrent",
    },
    valueTotalCurrent: {
      dataAid: "valueTotalCurrent",
    },
    currentValueIcon: {
      dataAid: "currentValue",
    },
    keyOneDayChange: {
      text: "1 day change:",
      dataAid: "keyOneDayChange",
    },
    valueOneDayChange: {
      dataAid: "valueOneDayChange",
    },
    pfFeatureCard: {
      dataAid: "currentInvestment",
      title: "Current investment",
      invested: "Invested",
      pl: "P&L",
      xirr: "XIRR",
      tooltipText: "This is your rate of return earned for the various investments made at different points in time",
      tooltipDataAid: "xirr",
    },
  },
  easySip: {
    title: "Set up easySIP",
    subtitle: "Authorise a one-time eMandate to enable auto-debit of your SIPs",
    dataAid: "easySip",
    loadingFailed: "Unable to load your external portfolio",
    refreshNow: "Refresh now",
  },
  bannerSection: {
    first: {
      iconDataAid: "marketingBanner",
    },
  },
  assetAllocationSection: {
    title: {
      text: "Asset allocation",
      dataAid: "assetAllocation",
    },
    viewDetails: {
      ctaTitle: "View details",
      ctaDataAid: "viewDetails",
      iconDataAid: "viewDetails",
    },
  },
  currentInvestmentSheet: {
    sheetId: 'currentInvestment',
    title: {
      text: "Current investment",
      dataAid: "title",
    },
    closeIcon: {
      dataAid: "close",
    },
    keyCurrent: {
      text: "Current value",
      dataAid: "keyCurrent",
    },
    keyInvested: {
      text: "Invested value",
      dataAid: "keyInvested",
    },
    keyProfitLoss: {
      text: "Profit & loss",
      dataAid: "keyProfit&Loss",
    },
    valueCurrent: {
      dataAid: "valueCurrent",
    },
    valueInvested: {
      dataAid: "valueInvested",
    },
    valueProfitLoss: {
      dataAid: "valueProfit&Loss",
    },
  },
  externalPortfolioFailed: {
    dataAid: "infoText",
    refreshBtnDataAid: "button_secondary",
  },
  walkThrough: {
    titleDataAid: "title",
    skipBtnDataAid: "skip",
    nextBtnDataAid: "next",
    skipBtnTitle: "Skip",
  },
  moreOptions: {
    header: {
      title: "More options",
      dataAid: "moreOptions"
    },
  }
};

export const ALLOCATIONS_LANDING = {
  screenDataAid: "allocationDetails",
  navigationHeader: {
    title: "Allocation details",
    dataAid: "allocationDetails",
  },
  keyCurrent: {
    text: "Current value",
    dataAid: "keyCurrent",
  },
  keyPl: {
    text: "P&L",
    dataAid: "keyP&L",
  },
  valueCurrent: {
    dataAid: "valueCurrent",
  },
  valuePl: {
    dataAid: "valueP&L",
  },
  pillHoldings: {
    title: "Holdings",
    dataAid: "holdings",
  },
  pillSectors: {
    title: "Sectors",
    dataAid: "sectors",
  },
};

export const SWITCH_ENTER_AMOUNT = {
  screenDataAid: 'switchFolio',
  header: {
    title: 'Enter amount to switch',
    dataAid: 'title',
    navDataAid: 'enterAmount'
  },
  switchFromToCard: {
    switchFromTitle: 'Switching from',
    switchFromDataAid: 'switchFrom',
    icLeftDataAid: 'left',
    fundNameDataAid: 'fundName',
    keyTotalUnitsTitle: 'Total units',
    keyTotalUnitsDataAid: 'keyTotalUnits',
    valueTotalUnitsDataAid: 'valueTotalUnits',
    keySwitchAmountTitle: 'Switchable amount',
    keySwitchAmountDataAid: 'keySwitchableAmount',
    valueSwitchAmountDataAid: 'valueSwitchableAmount',
    switchToTitle: 'Switching to',
    switchToTitleDataAid: "info",
    switchToFundDataAid: "title",
    switchToDataAid: 'switchingTo',
    separatorDataAid: '1',
    icSeparatorDataAid: 'switch'
  },
  selectFundCta: {
    title: 'Select different fund',
    dataAid: 'selectDifferentFund'
  },
  inputCard: {
    helperText: 'helperText',
    folioTitleDataAid: 'folioKey',
	  folioValueDataAid: 'folioValue',
    folioTitle: 'Folio',
    keyTotalAmount: 'Total amount',
    keyTotalAmountDataAid: 'keyTotalAmount',
    valueTotalAmountDataAid: 'valueTotalAmount',
    keyStcgTax: 'STCG Tax**',
    keyStcgTaxDataAid: 'keyStcgTax',
    valueStcgTaxDataAid: 'valueStcgTax',
    keyLtcgTax: 'LTCG Tax**',
    keyLtcgTaxDataAid: 'keyLtcgTax',
    valueLtcgTaxDataAid: 'valueLtcgTax',
    inputDataAid: 'enterSwitchAmount',
    switchCta: 'Switch all',
    switchCtaDataAid: 'switchAll',
    minAmountTitle: 'Min. balance required to switch is ',
    minAmountTitleDataAid: 'infoMinBal',
    inputPlaceholder: 'Enter amount',
    separatorDataAid: '1',
    switchableTitleDataAid: 'switchableAmountKey',
    switchableAmountTitle: 'Switchable amount',
    switchableValueDataAid: 'switchableAmountValue',
    viewTaxDetailsTitle: 'View tax details',
    viewTaxDetailsDataAid: 'viewTaxDetails'
  },
  cta: {
    title: 'Continue',
    dataAid: 'primary'
  }
};

export const SWITCH_OTP = {
  screenDataAid: 'enterOtpConfirmSwitch',
  bottomsheet: {
    dataAid: 'switchFailed',
    title: 'Switch failed',
    subtitle: 'Switch failed due to insufficient balance in your folio',
    ctaOne: 'Retry',
    ctaTwo: 'Back to Switch manager'
  },
  header: {
    title: 'Enter OTP to confirm switch',
    subtitle: 'An OTP has been sent to your registered mobile',
    dataAid: 'title',
    subtitleDataAid: 'subtitle',
    navDataAid: "enterOtp"
  },
  otpInput: {
    errorTitle: 'Invalid OTP',
    enterOtp: 'Please enter OTP.',
    otpTitle: 'You should get the OTP within',
    expOtpTitle: 'Didn’t get the OTP?',
    retryTitle: 'Retry',
    dataAid: 'enterOtp'
  },
  cta: {
    title: 'Confirm switch',
    dataAid: 'primary'
  }
};

export const SWITCH_FUNDS = {
  screenDataAid: 'switchFunds',
  header: {
    title: 'Switch funds',
    subtitle: 'Shift your investments from one scheme to the other within the same mutual fund',
    dataAid: 'title',
    subtitleDataAid: 'subtitle'
  },
  cta: {
    title: 'Select fund',
    dataAid: 'primary'
  },
  switchTo: {
    title: 'Switch to',
    subtitle: 'Select a mutual fund you wish to switch',
    dataAid: 'switchTitle',
    subtitleDataAid: 'switchSubtitle',
    label: 'All funds',
    labelDataAid: 'allFunds'
  },
  bottomsheet: {
    title: 'Fund type',
    titleDataAid: 'fundType',
    cta: 'Apply',
    ctaDataAid: 'primary',
    iconDataAid: 'close',
    checkIconDataAid: 'right',
    screenDataAid: 'fundType',
  },
  switchFrom: {
    dataAid: 'switchFrom',
    infoTitle: 'Switch from',
    unitsTitle: 'Total units',
    valueTitle: 'Total value',
    amountTitle: 'Switchable amt',
  },
  pleaseSelectFund:"Please select one of the switch fund",
  fundSelectionItem:{
    radioDataAid: 'radioButton_left',
    titleDataAid:'title',
    returnsDataAid:'return'
  },
  noFundsAvailable: {
    text: "No mutual funds available as per applied filter",
    dataAid: "title",
  },
};

export const HOLDING_DETAILS = {
  screenDataAid: 'holdingDetailsInvestments',
  menuDataAid: "holdingDetails",
  emptySipOrders: "No active SIPs",
  emptySuccesfullOrders: "No successful orders",
  emptyOrdersDataAid: "title",
  bottomsheet: {
    dataAid: 'currentInvestment',
    currentTitle: 'Current value',
    currentDataAid: 'keyCurrent',
    currentValueDataAid: 'valueCurrent',
    invTitle: 'Invested value',
    invDataAid: 'keyInvested',
    invValueDataAid: 'valueInvested',
    infoDataAid: 'information',
    noteTitle: 'Note:',
    noteDataAid: "note"
  },
  bottomsheetSwitch: {
    dataAid: 'switchUnavailable',
    icDataAid: 'top',
    title: 'Switch unavailable',
    titleDataAid: 'title',
    subtitle: `Each of this fund's folios has insufficient balance to switch units`,
    subtitleDataAid: 'subtitle',
    cta: 'Okay',
    ctaDataAid: 'primary'
  },
  rightMenu: {
    label1: 'Switch fund',
    label2: 'Withdraw'
  },
  header: {
    titleDataAid: 'title',
    icLeftDataAid: 'left',
    icRightDataAid: 'right',
    dataAid: "holdingDetails"
  },
  midSection: {
    currentRow: {
      title: 'Current value',
      dataAid: 'current',
      keyDataAid: 'keyCurrentValue',
      icDataAid: 'infoCurrentAmount',
      valueDataAid: 'valueCurrentValue'
    },
    investedRow: {
      title: 'Invested value',
      dataAid: 'investedValue',
      keyDataAid: 'keyInvested',
      valueDataAid: 'valueInvested'
    },
    unrealisedRow: {
      title: 'Unrealised gains',
      dataAid: 'unrealisedGains',
      keyDataAid: 'keyUnrealisedGains',
      valueDataAid: 'valueUnrealisedGains'
    },
    xirrRow: {
      title: 'XIRR',
      dataAid: 'xirr',
      keyDataAid: 'keyXirr',
      icInfoDataAid: 'infoXirr',
      icGrowthDataAid: 'growth',
      icReductionDataAid: 'reduction',
      valueDataAid: 'valueXirr',
      tootip: 'This is your rate of return earned for the various investments you’ve made at different points in time',
      tooltipDataAid: 'rateOfReturn'
    },
    avgNavRow: {
      title: 'Avg. NAV',
      dataAid: 'avgNav',
      keyDataAid: 'keyAverageNav',
      valueDataAid: 'valueAverageNav'
    },
    totalUnitsRow: {
      title: 'Total units',
      dataAid: 'totalUnits',
      keyDataAid: 'keyTotalUnits',
      valueDataAid: 'valueTotalUnits'
    },
    realisedGainRow: {
      title: 'Realised gain',
      dataAid: 'realisedGain',
      keyDataAid: 'keyRealisedGain',
      valueDataAid: 'valueRealisedGain'
    },
    lockInRow: {
      title: 'Lock-in',
      dataAid: 'lockIn',
      keyDataAid: 'keyLockIn',
      valueDataAid: 'valueLockIn',
      valueSubtext: 'Year'
    },
    folioRow: {
      title: 'Folio numbers',
      dataAid: 'folio',
      keyDataAid: 'keyFolioNumber',
      valueDataAid: 'valueFolioNumber'
    }
  },
  switchFromToCard: {
    switchFromTitle: 'Switch from',
    switchFromDataAid: 'label1',
    icLeftDataAid: 'left',
    titleLeftDataAid: 'label',
    firstSection: {
      icDataAid: 'left1',
      titleDataAid: 'title1',
      valueDataAid: 'value1',
    },
    secondSection: {
      icDataAid: 'left2',
      titleDataAid: 'title2',
      valueDataAid: 'value2',
    },
    switchToTitle: 'Switch to',
    switchToDataAid: 'label2',
    separatorDataAid: '1',
    icSeparatorDataAid: 'center',
    separatorTwoDataAid: '2',
    dateDataAid: 'date',
    tagDataAid: 'label'
  },
  fundDetailCardDataAid: 'successful',
  cta: {
    title: 'Invest more',
    dataAid: 'primary'
  }
};

export const YOUR_FUNDS = {
  screenDataAid: 'fundHoldings',
  title: "My funds",
  investedIn: {
    title: 'Invested in',
    dataAid: 'investedIn',
    keyDataAid: 'keyInvested',
    valueDataAid: 'valueInvested'
  },
  totalValue: {
    title: 'Total value',
    dataAid: 'totalValue',
    keyDataAid: 'keyTotalValue',
    valueDataAid: 'valueTotalValue'
  },
  xirr: {
    title: 'XIRR',
    dataAid: 'xirr',
    keyDataAid: 'keyXirr',
    valueDataAid: 'valueXirr'
  },
  note: {
    text: "Note: XIRR stands for Extended Internal Rate of Return & is a method used to calculate returns on investments",
    dataAid: "note"
  },
  filterNavigation: {
    dataAid: "filterList",
    sort : {
      title: "Sort",
      dataAid: "1"
    },
    filter : {
      title: "Filter",
      dataAid: "2"
    }
  },
  sortBottomSheet: {
    dataAid: 'sorting',
    cta: {
      title: 'Apply',
      dataAid: 'primary'
    },
    title: {
      text: 'Sort',
      dataAid: 'sort'
    },
    iconDataAid: 'close',
    checkIconDataAid: 'check',
  },
  filterBottomSheet: {
    dataAid: "filtersCategory",
    header: {
      title: "Filters",
      actionTitle: "Clear all",
      dataAid: "filters",
    },
    cta: {
      title: "apply",
      dataAid: "primary"
    },
    search : {
      placeholder: "Search...",
      dataAid: "filters"
    },
    noResults : {
      text: "No results",
      dataAid: "noResult"
    }
  },
  fundsList: {
    investedTitle: 'Invested',
    currentTitle: 'Current',
    xirrTitle: 'XIRR'
  },
  noFunds: {
    title: "No Funds Available",
    dataAid: "title"
  }
};

export const MISSED_SIP_DATA = {
  title: 'Missed SIP',
  subtitle: 'Please pay this month’s SIP',
  dataAid: 'missedSip',
};

export const SWITCH_SUCCESS = {
  screenDataAid: 'switchPlaced',
  lottieDataAid: 'success',
  title: 'Switch request placed',
  titleDataAid: 'title',
  subtitle: 'Funds will reflect in your portfolio once units are switched successfully',
  subtitleDataAid: 'subtitle'
};

export const ORDER_DETAILS = {
  screenDataAid: 'orderDetails',
  header: {
    title: 'Order details',
  },
  infoCard: {
    dataAid: 'easySip',
    title: 'Set up easySIP',
    subtitle: 'Authorise eMandate to enjoy automatic investments'
  },
  status: {
    title: 'Status',
    dataAid: 'status'
  },
  orderCard: {
    dateDataAid: 'date',
    labelDataAid: 'label',
    icLeftDataAid: 'left',
    titleDataAid: 'title',
    icRightDataAid: 'right',
    keyAmount: 'Total amount',
    keyAmountDataAid: 'keyAmount',
    valueAmountDataAid: 'valueAmount',
    keyUnits: 'Units',
    keyUnitsDataAid: 'keyUnits',
    valueUnitsDataAid: 'valueUnits',
    keyNav: 'NAV',
    keyNavDataAid: 'keyNav',
    valueNavDataAid: 'valueNav',
    keyExit: 'Exit load',
    keyExitDataAid: 'keyExitLoad',
    valueExitDataAid: 'valueExitLoad',
    icTooltipExitDataAid: 'exitLoad',
    tooltipText: 'Refers to a fee charged by fund houses for exiting or withdrawing fund units',
    tooltipDataAid: 'exitLoad',
    keyWithdraw: 'Est. withdrawal amount',
    keyWithdrawDataAid: 'keyEstWithdrawalAmount',
    valueWithdrawDataAid: 'valueEstWithdrawalAmount',
    keyCreditedAmount: 'Credited amount',
    keyBankAcc: 'Bank account',
    keyBankAccDataAid: 'keyBankAccount',
    valueBankAccDataAid: 'valueBankAccount',
    separatorDataAid: '1',
    infoText: "Paid via easySIP",
    infoTextDataAid: "informationalText"
  },
  bottomsheetDetails: {
    dataAid: 'orderDetails',
    title: 'More details',
    titleDataAid: 'title',
    pointDataAid: 'point'
  },
  switchCard: {
    icSwitchDataAid: 'center',
    dataAid: "switch",
    switchFrom: {
      title: 'Switch from',
      dataAid: 'label1',
      icLeftDataAid: 'left1',
      icRightDataAid: 'right1',
      fundTitleDataAid: 'title1',
      separatorDataAid: '1',
    },
    switchTo: {
      title: 'Switch to',
      dataAid: 'label2',
      icLeftDataAid: 'left2',
      icRightDataAid: 'right2',
      fundTitleDataAid: 'title2',
      separatorDataAid: '2'
    }
  },
  steps: {
    status: "Status",
    statusDataAid: "status",
    paymentSuccess: 'Payment successful',
    paymentSuccessInfo: 'Payment for your order received',
    immediate: 'Immediate',
    oneWorkingData: "1 working day",
    twoWorkingDays: "2 working days",
    upToThreeWorkingDays: "2-3 working days",
    threeToSixWorkingDays: "3-6 working days",
    orderPlaced: 'Order placed',
    orderPlacedInfo: 'Payment & order details sent to fund house',
    orderPlaceWithdrawInfo: 'Order sent to fund house',
    unitsAlloted: 'Units alloted',
    unitsAllotedInfo: 'Units allotted by fund house',
    investConfirm: 'Investment confirmed',
    investConfirmInfo: 'Portfolio updated',
    investConfirmSwitchInfo: 'Confirmation of switch received',
    autoDebit: 'Auto-debit successful',
    autoDebitInfo: 'Payment for your order received',
    cta: 'View more details',
    withdrawReq: 'Withdraw requested',
    withdrawReqInfo: 'Withdraw request received',
    unitsDeduct: 'Units deducted',
    unitsDeductInfo: 'Units deducted by fund house',
    withdrawAmountCredit: 'Withdrawal amount credited',
    withdrawAmountCreditInfo: 'Amount credited to bank A/c.',
    creditCheque: 'Credit cheque issued',
    creditChequeInfo: 'Cheque sent to your address',
    switchReq: 'Switch requested',
    switchReqInfo: 'Switch request received',
    unitSwitch: 'Units switched',
    unitSwitchInfo: 'Balance deducted & units switched successfully',
  }
};


export const YOUR_ORDERS = {
  screenDataAid: "orderBook",
  header: {
    title: "My orders",
    subtitle: "View the status of your mutual fund orders",
    dataAid: "orderBook",
  },
  emptyInprogressOrders: "No orders in progress",
  emptySuccesfullOrders: "No successful orders",
  emptyOrdersDataAid: "title",
  filterData: {
    header: {
      title: "Filters",
      actionTitle: "Clear all",
      dataAid: "filters",
    },
    buttonTitle: "Apply",
    dataAid: "filtersInvestmentTypes",
    navigation: {
      title1: "Filter",
      dataAid1: "1",
      title2: "Date",
      dataAid2: "2",
    },
  },
  dateFilterData: {
    header: {
      title: "Select date",
      actionTitle: "Clear all",
      dataAid: "selectDateRange",
    },
    buttonTitle: "Apply",
    screenDataAid: "selectDateRange",
    datePicker1: {
      label: 'From',
      dataAid: 'fromDate',
      bottomsheetDataAid: "from",
      selectDateMessage: "Please select start date",
      cta:"Select Date"
    },
    datePicker2: {
      label: 'To',
      dataAid: 'toDate',
      bottomsheetDataAid: "to",
      selectDateMessage: "Please select end date",
      cta:"Select Date"
    }
  },
  footer: {
    infoText: "Can't find your orders here? Visit",
    infoTextDataAid: "infoText",
    buttonTitle: "Support",
    buttonDataAid: "secondary",
  },
};

export const SIP_LANDING = {
  screenDataAid: "sipManager",
  navigationHeader: {
    title: "SIP manager",
    dataAid: "sipManager",
  },
  monthlySipInfoCard: {
    monthlySipAmount: {
      text: "Monthly SIP amount",
      dataAid: "monthlySipAmount"
    },
    sipAmount: {
      dataAid: "sipAmount"
    },
    activeSip: {
      text: "active SIPs",
      dataAid: "activeSip",
    }
  },
  missedSip: {
    dataAid: "missedSip",
    title: "Missed SIP",
    subtitle: "Please pay this month's SIP"
  },
  easySip: {
    dataAid: "easySip",
    title: "Set up easySIP",
    subtitle: "Authorise one-time eMandate to automate your upcoming SIPs"
  },
  recentSipHeader: {
    title: "All SIPs",
    titleDataAid: "allSip",
    buttonTitle: "See all",
    buttonDataAid: "seeAllRecentSip",
    icDataAid: 'seeAll'
  },
  sipDetailsCard: {
    dataAid: 'activeSip',
    sipAmount: "SIP amount",
    sipDate: "SIP date"
  },
  upcomingSipInfoCard: {
    dataAid: "upcomingSip",
    title: "Upcoming SIPs",
    subtitle: "View details"
  }
};

export const ALL_SIP_SCREEN = {
  screenDataAid: "allSips",
  navigationHeader: {
    title: "All SIPs",
    dataAid: "allSips"
  },
  monthlySipInfoCard: {
    monthlySipAmount: {
      text: "Monthly SIP amount",
      dataAid: "monthlySipAmount"
    },
    sipAmount: {
      dataAid: "sipAmount"
    },
    activeSip: {
      text: "active SIPs",
      dataAid: "activeSip",
    }
  },
  sipDetailsCard: {
    dataAid: 'activeSip',
    sipAmount: "SIP amount",
    sipDate: "SIP date"
  },
  noSips: {
    dataAid: "title",
    title: "No mutual funds available as per applied filter",
  },
  footer: {
    sortTitle: 'Sort',
    filterTitle: 'Filter'
  },
  sortBottomSheet: {
    dataAid: 'sortingSips',
    cta: {
      title: 'Apply',
      dataAid: 'primary'
    },
    title: {
      text: 'Sort by',
      dataAid: 'sortBy'
    },
    iconDataAid: 'close',
    checkIconDataAid: 'check',
  },
  filterBottomSheet: {
    dataAid: "filters",
    header: {
      title: "Filters",
      actionTitle: "Clear all",
      dataAid: "filters",
    },
    cta: {
      title: "apply",
      dataAid: "primary"
    }
  },
};

export const UPCOMING_SIP = {
  screenDataAid: "upcomingSips",
  navigationHeader: {
    title: "Upcoming SIPs",
    dataAid: "upcomingSips"
  },
  cards: {
    dataAid: 'upComingSip',
    dueDate: "Due on",
  },
  upcomingSip: {
    key: "Total SIP amount",
    keyDataAid: "totalAmountKey",
    valueDataAid: "totalAmountValue"
  }
};

export const EDIT_SIP_PROGRESS = {
	screenDataAid: "editInProgressSip",
	header: {
		dataAid: "editInProgressSip",
		statusDataAid: 'indicator',
		titleDataAid: 'title',
		icDataAid: 'right',
		newAmount: {
			text: "New amount",
			keyDataAid: "keyNewAmount",
			valueDataAid: "valueNewAmount"
		},
		oldAmount: {
			text: "Old amount",
			keyDataAid: "keyOldAmount",
			valueDataAid: "valueOldAmount"
		},
		newDate: {
			text: "New date",
			keyDataAid: "keyNewDate",
			valueDataAid: "valueNewDate"
		},
		oldDate: {
			text: "Old date",
			keyDataAid: "keyOldDate",
			valueDataAid: "valueOldDate"
		},
	},
	status: {
		title: 'Status',
		titleDataAid: 'status',
		infoCardTitle: 'Edit SIP requested',
		infoCardSubtitle: 'Edit SIP request received. We’ll notify you once done',
		infoCardDataAid: 'editSipRequested'
	}
};

export const SIP_STATUS_DETAILS = {
	screenDataAid: 'sipStatusDetails',
  navigationHeaderDataAid: 'sipStatusDetails',
	resumeSipRequested: {
		dataAid: "resumeSipRequested",
		title: "Resume SIP requested",
		subtitle: "Resume SIP request received. We’ll notify you once done"
	},
	status: {
		text: "Status",
		dataAid: "status"
	},
	restartSipRequested: {
		dataAid: "restartSipRequested",
		title: "Restart SIP requested",
		subtitle: "Restart SIP request received. We’ll notify you once done"
	},
	cta: {
		restartSip: 'Restart sip',
		resumeSip: 'Resume sip',
		dataAid: 'primary'
	},
	pauseRequestedStatus: {
		step1: {
		  text: "Pause requested",
		  stepCount: 1
		},
		step2: {
		  text: "SIP paused",
		  stepCount: 2
		}
	},
	cancelRequestedStatus: {
		step1: {
		  text: "Cancel requested",
		  stepCount: 1
		},
		step2: {
		  text: "SIP cancelled",
		  stepCount: 2
		}
	},
	bottomsheet: {
    resumeDataAid: 'resumeSip',
		restartDataAid: "restartSip",
		title: {
		  restartSip: "Restart SIP",
		  resumeSip: "Resume SIP",
		  dataAid: "title"
		},
		subtitle: {
		  icDataAid: "left",
		  dataAid: "label"
		},
		nextSipDate: {
		  text: "Next SIP date -",
		  keyDataAid: "key1",
		  valueDataAid: "value1"
		},
		sipAmount: {
		  text: "SIP Amount -",
		  keyDataAid: "key2",
		  valueDataAid: "value2"
		},
		cta: {
		  restartText: "Restart",
		  resumeText: "Resume",
		  dataAid: "primary"
		}
	},
};

export const SIP_DETAILS = {
  screenDataAid: "activeSip",
  navigationHeaderDataAid: "activeSip",
  headerTitleDataAid: '1',
  statusDataAid: 'indicator',
  headerTitle: {
    icDataAid: 'right',
    titleDataAid: 'title'
  },
  sipAmount: {
    text: "SIP amount",
    keyDataAid: "keySipAmount",
    valueDataAid: "valueSipAmount"
  },
  sipDate: {
    text: "Monthly SIP date",
    keyDataAid: "keyMonthlySipDate",
    valueDataAid: "valueMonthlySipDate"
  },
  easySip: {
    title: "Set up easySIP",
    subtitle: "Authorise one-time eMandate to automate your upcoming SIPs",
    dataAid: "easySip",
  },
  status: {
    text: "Status",
    dataAid: "status"
  },
  step1: {
    dataAid: 1,
    stepCount: 1,
    title: "Mandate created",
    subtitle: "Approval is pending from your bank"
  },
  step2: {
    dataAid: 2,
    stepCount: 2,
    title: "Mandate approved",
    subtitle: "Mandate for auto-debit approved by bank"
  },
  step3: {
    dataAid: 3,
    stepCount: 3,
    title: "easySIP activated",
    subtitle: "SIP amount will start to get auto-debited"
  },
  editSipInfoCard: {
    dataAid: 'editSip',
    subtitle: "With Edit SIP you can increase/decrease your SIP amount & modify the SIP date"
  },
  footerButton1: {
    text: "EDIT SIP",
    dataAid: "primaryEdit"
  },
  footerButton2: {
    text: "PAUSE/CANCEL",
    dataAid: "primaryPauseCancel"
  },
  bottomsheet: {
    dataAid: "sipOption",
    title: "SIPs help to build wealth",
    titleDataAid: "sipBuildWealth",
    icDataAid: 'left',
    subtitle: "Stay invested for at least 3 years to get the most out of your SIP",
    subtitleDataAid: "stayInvested",
    option1: {
      dataAid: "pauseSip",
      title: "Pause SIP",
      titleDataAid: "pauseSipTitle",
      subtitle: "Instead of cancelling, we suggest you pause SIP for a few months & reactivate it later",
      subtitleDataAid: "pauseSipSubtitle",
    },
    option2: {
      dataAid: "cancelSip",
      title: "Cancel SIP",
      titleDataAid: "cancelSipTitle"
    },
    cta: {
      text: "Continue",
      dataAid: 'primary'
    }
  },
};

export const EDIT_SIP = {
  screenDataAid: 'editSip',
  header: {
    title: 'Edit SIP',
    dataAid: 'editSip'
  },
  headerTitleDataAid: 'title',
  invCard: {
    dataAid: 'editSip',
    sipAmount: 'SIP amount',
    subtitle: 'Minimum investment amount is ₹100',
    monthlySipDate: 'Monthly SIP date',
    monthlySipDateValue: "of every month"
  },
  cta: {
    dataAid: 'primary',
    title: 'apply changes'
  },
  dateBottomsheet: {
    availableDates: 'Available dates',
    selectDate: 'Select date',
    ofEveryMonth: 'of every month',
    dataAid: 'availableDates'
  },
  confirmBottomSheet: {
    dataAid: "confirmation",
    icDataAid: "top",
    date: {
      dataAid: "confirmDate",
      title: "Confirm revised date",
    },
    amount: {
      dataAid: "confirmAmount",
      title: "Confirm revised amount",
    },
    amountDate: {
      dataAid: "confirmAmountDate",
      title: "Confirm revised amount & date",
    },
    datePoint: {
      text: "SIP date",
      keyDataAid: "keySipDate",
      valueDataAid: "valueSipDate",
    },
    amountPoint: {
      text: "SIP amount",
      keyDataAid: "keySipAmount",
      valueDataAid: "valueSipAmount",
    },
    cta: {
      text: "Continue",
      dataAid: "primary"
    },
  },
  limitExceeded: {
    dataAid: "mandateLimit",
    title: {
      text: "Mandate limit exceeded",
      dataAid: "title",
    },
    subtitle: {
      text: "Please contact Fisdom Support to increase the mandate limit (amount)",
      dataAid: "subtitle",
    },
    primaryCta: {
      text: "contact support",
      dataAid: "primary"
    },
    secondaryCta : {
      text: "maybe later",
      dataAid: "secondary"
    }
  }
};

export const PAUSE_SIP = {
  screenDataAid: "pauseSip_selectPeriod",
  header: {
    icDataAid: "left",
    dataAid: "pauseSip",
    title: {
      dataAid: "title",
      text: "Pause SIP"
    },
    subtitle: {
      dataAid: "subtitle",
      text: "For how many months do you want to pause SIP?",
    },
	slider: {
		dataAid: "pauseSip",
		valueDataAid: "sliderValue"
	  },
	  sliderRange: {
		min: {
		  text: "1 month",
		  dataAid: "1Month"
		},
		max: {
		  text: "6 months",
		  dataAid: "6Month"
		}
	  },
	},
    info: {
      dataAid: "sipHelp",
      subtitle: "SIPs help to create more wealth over time. Pause SIP only if unavoidable"
    },
    cta: {
      text: "continue",
      dataAid: "primary"
    }
};

export const SIP_ENTER_OTP = {
  screenDataAid: "enterOtp",
  header: {
    dataAid: "enterOtp",
    icDataAid: "left",
    title: {
      text: "Enter OTP",
      dataAid: "title"
    },
    subtitle: {
      text: "An OTP has been sent to your registered mobile",
      dataAid: "subtitle"
    },
},
    otp: {
      dataAid: "enterOtp",
      helperText: "OTP will receive in",
      retryInfoText: "Didn’t get the OTP?",
      retryTitle: "Resend"
    },
    cta: {
      text: "confirm",
      dataAid: "primary"
    }
};

export const REQUEST_SUCCESS = {
  editSip: {
    screenDataAid: "editSipRequestPlaced",
    headerDataAid: "editSipRequestPlaced",
    title: "Edit SIP request placed",
    point1: "SIP amount",
    point2: "SIP date",
    cta: {
      dataAid: "primary",
      text: "Okay"
    }
  },
  pauseSip: {
    screenDataAid: "sipPauseRequestPlaced",
    headerDataAid: "sipPauseRequest",
    title: "SIP pause request placed",
    point1: "Pause period",
    point2: "Pause date",
    infoCard: {
      dataAid: "sipInfo",
      subtitle: "You can resume your SIP anytime"
    },
    cta: {
      dataAid: "primary",
      text: "Okay"
    }
  },
  cancelSip: {
    screenDataAid: "sipCancelRequestPlaced",
    headerDataAid: "sipCancelRequest",
    title: "SIP cancel request placed",
    point1: "Cancel date",
    infoCard: {
      dataAid: "sipInfo",
      subtitle: "Amount you’ve invested will stay invested. You can restart your SIP anytime"
    },
    cta: {
      dataAid: "primary",
      text: "Okay"
    }
  },
  resumeSip: {
    screenDataAid: "resumeSipRequestPlaced",
    headerDataAid: "resumeSipRequest",
    title: "Resume SIP request placed",
    subtitle: "We’ll send you a confirmation email once your SIP is resumed successfully",
    point1: "Resume date",
    cta: {
      dataAid: "primary",
      text: "Okay"
    }
  },
  restartSip: {
    screenDataAid: "restartedSip",
    headerDataAid: "restartSipRequest",
    title: "Restart SIP request placed",
    subtitle: "We’ll send you a confirmation email once your SIP restart request is processed successfully",
    point1: "Restart date",
    cta: {
      dataAid: "primary",
      text: "Okay"
    }
  }
};